import React from "react";
import { Link } from "react-router-dom";
import Footer from "../shared/footer/Footer";

const Error = () => {
  return (
    <div>
      <div className="h-screen overflow-hidden relative">
        <div class="   p-10 lg:p-20 text-gray-800 relative md:flex items-center text-center md:text-left">
          <div class="w-full">
            <div class="mb-10 lg:mb-20">
              <Link to="/" className="flex items-center justify-start gap-3 ">
                <img
                  loading="lazy"
                  src="/images/Frame-1.svg"
                  alt="Hightable_logo"
                />
              </Link>
            </div>
            <div class="mb-10 md:mb-20 text-gray-600 font-light">
              <h1 class="font-black uppercase text-3xl lg:text-5xl text-yellow-500 mb-10">
                You seem to be lost!
              </h1>
              <p>The page you're looking for isn't available.</p>
              <p>Try searching again or use the Go Back button below.</p>
            </div>
            <div class="mb-20 md:mb-0 flex">
              <Link
                to={"/"}
                class="text-lg flex  items-center gap-1 font-light outline-none focus:outline-none transform transition-all hover:scale-110 text-gray-500 hover:text-yellow-600"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-arrow-left"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8"
                  />
                </svg>
                Go Back
              </Link>
            </div>
          </div>
          <img
            className="w-[30rem]"
            src="https://img.freepik.com/free-vector/404-error-with-person-looking-concept-illustration_114360-7922.jpg?t=st=1737710501~exp=1737714101~hmac=5de86c5144c1756edb18077540b6d461c748eacd61fb19a9e55c6514138b33e2&w=740"
          />
        </div>
        <div class="w-64 md:w-96 h-96 md:h-full bg-blue-200 bg-opacity-30 absolute -top-64 md:-top-96 right-20 md:right-32 rounded-full pointer-events-none -rotate-45 transform"></div>
        <div class="w-96 h-full bg-yellow-200 bg-opacity-20 absolute -bottom-96 right-64 rounded-full pointer-events-none -rotate-45 transform"></div>
      </div>
    </div>
  );
};

export default Error;
